export default __webpack_public_path__ + "static/media/SemDadosAlarme.5f2ec776.svg";